<template>
    <div class="docking_service"> 
        <Header :type="2" :sub-type="8"></Header>
        <div class="banner"></div>
        <div class="service main_width main_color m_0">
            <div class="service_title">服务范围</div>
            <div class="service_content">
                <div class="service_item" v-for="(item, index) in serviceList" :key="index">
                    <img :src="item.img" alt="">
                    <div>
                        <div>{{ item.title }}</div>
                        <div class="desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="advantage main_width main_color m_0">
            <div class="advantage_title">为什么我们更专业</div>
            <div class="advantage_desc">4大核心优势 问鼎汽配行业</div>
            <div class="advantage_content">
                <div class="advantage_content_box">
                    <div class="advantage_content_left">
                        <div class="top"></div>
                        <div class="border">响应速度</div>
                        <div class="border">数据量</div>
                        <div class="border">准确率</div>
                        <div>数据维度</div>
                    </div>
                    <div class="advantage_content_centen">
                        <div class="advantage_content_centen_top">汽修宝数据接口</div>
                        <div>全接口响应时间＜30ms， 数据查询不用等</div>
                        <div>原厂数据，从源头保证数据 真实性与完整性</div>
                        <div>拥有专业数据团队从市场上 收集最新数据</div>
                        <div>品牌数量多，丰富覆盖多个 方面与类型的参数</div>
                    </div>
                    <div class="advantage_content_right">
                        <div class="top">第三方数据接口</div>
                        <div class="border">响应速度慢，严重影响工作效率</div>
                        <div class="border">没有渠道收集完整的数据，可用性差</div>
                        <div class="border">过时数据，无法保证准确率与适用性</div>
                        <div>东拼西凑的数据，不完整且覆盖率不全</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '../../components/header.vue'
import VIN from '../../../static/images2/vin.webp'
import EPC from '../../../static/images2/epc.webp'
import OEM from '../../../static/images2/oem.webp'
import Data from '../../../static/images2/data.webp'
import Maintenance from '../../../static/images2/maintenance.webp'
import BeInDanger from '../../../static/images2/be_in_danger.webp'
import VehicleModel from '../../../static/images2/vehicle_model.webp'
import AD from '../../../static/images2/ad.webp'
export default {
    name: "dockingService",
    components: {
        Header
    },
    data() {
        return {
            serviceList: [
                {
                    img: VIN,
                    title: 'VIN车架号',
                    desc: '根据17位VIN编码查询车辆信息'
                },
                {
                    img: EPC,
                    title: '结构图(EPC)',
                    desc: '可查询90个品牌车辆结构与配件'
                },
                {
                    img: OEM,
                    title: 'OEM查询',
                    desc: '2000万+原厂配件数据'
                },
                {
                    img: Data,
                    title: '原厂数据',
                    desc: '可直查官方生产数据信息'
                },
                {
                    img: Maintenance,
                    title: '维修保养记录',
                    desc: '了解车辆过往维修情况'
                },
                {
                    img: BeInDanger,
                    title: '出险理赔记录',
                    desc: '了解车辆维修情况'
                },
                {
                    img: VehicleModel,
                    title: '车辆状况报告',
                    desc: '多维度分析车辆整体健康情况'
                },
                {
                    img: AD,
                    title: '广告投放',
                    desc: '智能化数据采集、多场景分析'
                },
            ]
        }
    },
    methods: {
        
    }
}
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
div {
    box-sizing: border-box;
}
.banner {
    height: 25vw;
    // min-height: 330px;
    width: 100%;
    background-image: url('../../../static/images2/docking_service_banner.webp');
    background-color: #ebf2fe;
    background-repeat: no-repeat;
    background-size: cover;
}
.service {
    text-align: center;
    margin-bottom: .px2vw(52)[@result];
    .service_title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        line-height: .px2vw(40)[@result];
        margin: .px2vw(48)[@result] 0 .px2vw(23)[@result];
    }
    .service_content {
        width: .px2vw(1280)[@result];;
        font-weight: 400;
        font-size: .px2vw(20)[@result];
        padding: .px2vw(24)[@result] .px2vw(80)[@result];
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 0 auto;
        & > div {
            width: .px2vw(250)[@result];
            padding: .px2vw(20)[@result] 0 .px2vw(24)[@result];
            margin-bottom: .px2vw(40)[@result];
            img {
                width: .px2vw(48)[@result];
                height: .px2vw(48)[@result];
                margin-bottom: .px2vw(4)[@result];
            }
            .desc {
                font-weight: 400;
                font-size: .px2vw(14)[@result];
                color: #4E5969;
                line-height: .px2vw(22)[@result];
                margin-top: .px2vw(8)[@result];
            }
        }
    }
}
.advantage {
    text-align: center;
    margin-bottom: .px2vw(87)[@result];
    .advantage_title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(16)[@result];
    }
    .advantage_desc {
        font-weight: 400;
        font-size: .px2vw(14)[@result];
        color: #4E5969;
        line-height: .px2vw(22)[@result];
        margin-bottom: .px2vw(56)[@result];
    }
    .advantage_content {
        width: .px2vw(726)[@result];
        min-width: 600px;
        margin: 0 auto;
        .advantage_content_box {
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient( 180deg, #F7FCFF 0%, #FFFFFF 100%);
            box-shadow: .px2vw(-7)[@result] .px2vw(5)[@result] .px2vw(19)[@result] 0px rgba(189,203,216,0.3);
            border-radius: .px2vw(12)[@result];
            & > div {
                width: .px2vw(242)[@result];
                flex: 1;
                & > div {
                    height: .px2vw(120)[@result];
                    line-height: .px2vw(32)[@result];
                    display: flex;
                    align-items: center;
                    
                    justify-content: center;
                }
                & > .top {
                    height: .px2vw(96)[@result];
                    font-weight: 700;
                    font-size: .px2vw(20)[@result];
                    color: #1D2129 !important;
                    background-color: transparent !important;
                }
                .border {
                    border-bottom: 1px solid #E3E5E8;
                }
            }
            .advantage_content_left {
                text-align: left;
                & > div {
                    justify-content: space-between;
                    padding-left: .px2vw(40)[@result];
                    color: #4E5969;
                    background: #FFFFFF;
                }
            }
            .advantage_content_centen {
                width: .px2vw(242)[@result];
                margin-top: .px2vw(-24)[@result];
                margin-bottom: .px2vw(-24)[@result];
                padding: .px2vw(24)[@result] .px2vw(28)[@result];
                background: linear-gradient( 180deg, #228DFF 0%, #16B5FF 100%);
                border-radius: .px2vw(40)[@result];
                flex: 0 0 .px2vw(242)[@result];
                color: #ffffff;
                font-weight: 700;
                font-size: .px2vw(16)[@result];
                .advantage_content_centen_top {
                    height: .px2vw(96)[@result];
                    font-size: .px2vw(20)[@result];
                    background-color: transparent !important;
                }
            }
            .advantage_content_right {
                & > div {
                    padding: 0 .px2vw(24)[@result] 0 .px2vw(26)[@result];
                    color: #4E5969;
                    background: #FFFFFF;
                }
            }
        }
    }
}


@media screen and (max-width: 900px) {
    .banner {
        height: .h5px2vw(702)[@result];
        background-image: url('../../../static/images2/h5/docking_service_banner.webp');
    }
    .service {
        margin-bottom: .h5px2vw(56)[@result];
        .service_title {
            font-size: .h5px2vw(32)[@result];
            line-height: .h5px2vw(40)[@result];
            margin: .h5px2vw(32)[@result] 0;
        }
        .service_content {
            width: 100%;
            font-size: .h5px2vw(24)[@result];
            padding: 0 .h5px2vw(24)[@result];
            & > div {
                width: .h5px2vw(338)[@result];
                padding: .h5px2vw(24)[@result];
                margin-bottom: .h5px2vw(24)[@result];
                display: flex;
                text-align: left;
                img {
                    width: .h5px2vw(64)[@result];
                    height: .h5px2vw(64)[@result];
                    margin-bottom: 0;
                    margin-right: .h5px2vw(16)[@result];
                }
                .desc {
                    font-weight: 400;
                    color: #4E5969;
                    font-size: .h5px2vw(24)[@result];
                    line-height: .h5px2vw(32)[@result];
                    margin-top: .h5px2vw(8)[@result];
                }
            }
        }
    }
    .advantage {
        margin-bottom: 0;
        padding: 0 .h5px2vw(24)[@result] .h5px2vw(74)[@result];
        .advantage_title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(16)[@result];
        }
        .advantage_desc {
            font-size: .h5px2vw(14)[@result];
            line-height: .h5px2vw(22)[@result];
            margin-bottom: .h5px2vw(24)[@result];
            padding-bottom: .h5px2vw(24)[@result];
        }
        .advantage_content {
            width: 100%;
            min-width: auto;
            .advantage_content_box {
                box-shadow: .h5px2vw(-7)[@result] .h5px2vw(5)[@result] .h5px2vw(19)[@result] 0px rgba(189,203,216,0.3);
                border-radius: .h5px2vw(12)[@result];
                & > div {
                    // width: .h5px2vw(242)[@result];
                    font-size: .h5px2vw(24)[@result];
                    & > div {
                        height: .h5px2vw(120)[@result];
                        line-height: .h5px2vw(28)[@result];
                    }
                    & > .top {
                        height: .h5px2vw(96)[@result];
                        font-size: .h5px2vw(20)[@result];
                    }
                    .border {
                        border-bottom: 1px solid #E3E5E8;
                    }
                }
                .advantage_content_left {
                    width: .h5px2vw(168)[@result];
                    flex: 0 0 .h5px2vw(168)[@result];
                    & > div {
                        padding-left: .h5px2vw(40)[@result];
                    }
                }
                .advantage_content_centen {
                    width: .h5px2vw(296)[@result];
                    margin-top: .h5px2vw(-24)[@result];
                    margin-bottom: .h5px2vw(-24)[@result];
                    padding: .h5px2vw(24)[@result] .h5px2vw(28)[@result];
                    border-radius: .h5px2vw(40)[@result];
                    flex: 0 0 .h5px2vw(296)[@result];
                    font-size: .h5px2vw(20)[@result];
                    .advantage_content_centen_top {
                        height: .h5px2vw(90)[@result];
                        font-size: .h5px2vw(28)[@result];
                    }
                }
                .advantage_content_right {
                    & > div {
                        padding: 0 .h5px2vw(24)[@result] 0 .h5px2vw(26)[@result];
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/dockingService/index.vue